import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as survey from '../survey'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: survey.RESOURCE.payload.dimension.partialId,
      partialId: survey.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    description: 'Space survey functionalization methodology',
    isOptional: true,
    name: 'Functionalization Methodology',
    partialId: PartialId.Standard.create('func_method'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.spaceSurveyFuncMethod.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
